import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const DesktopWrapper = styled.div`
  display: flex;
  margin-top: 34px;
  margin-left: -16px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: flex;
    margin-top: 24px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: ${breakpoints.m}) {
    display: flex;
  }
`;
